import Form from 'components/creditCard/Form/styled';

export default Form;
